export default "__VITE_ASSET__DMIf0tnA__"